module.exports = __webpack_public_path__ + "static/img/footer_h5icon_02_zh.b59dcfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_h5icon_02_zh.png
// module id = qKGh
// module chunks = 34